import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { FormikProps } from "formik";
import { useRef, useState } from "react";

import AddAllowanceForm from "@/features/allowance/components/addAllowance/AddAllowanceForm";
import { AllowanceBaseModel } from "@/features/allowance/types/allowanceModels";
import { RDialog } from "@/shared/components/forms";
import useProjectWBSContext from "@/shared/context/projectWBS/useProjectWBSContext";

export type AddAllowanceProps = {
  refetchAllowance: () => void;
};

export default function AddAllowanceButton({ refetchAllowance }: AddAllowanceProps) {
  const [isModalOpen, setModalOpen] = useState(false);
  const addFormikRef = useRef<FormikProps<AllowanceBaseModel>>(null);
  const { refetchProjectWBS } = useProjectWBSContext();
  const [isFormValid, setIsFormValid] = useState(false);

  const addAllowance = async () => {
    if (addFormikRef.current) {
      await addFormikRef.current.submitForm();
    }
    refetchAllowance();
    refetchProjectWBS();
  };
  const handleSubmitForm = () => {
    void addAllowance();
    handleClose();
  };

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        backgroundColor: "white",
        borderRadius: "4px",
        marginTop: "24px",
      }}>
      <Button
        onClick={handleOpen}
        variant="outlined"
        size="large"
        sx={{
          marginTop: "10px",
          marginBottom: "14px",
          marginLeft: "10px",
          fontWeight: "bold",
        }}>
        Add Allowance
      </Button>
      <RDialog
        isOpen={isModalOpen}
        title="Add Allowance"
        confirmButtonCallback={handleSubmitForm}
        cancelButtonCallback={handleClose}
        confirmButtonText="Create"
        confirmButtonType="primary"
        confirmButtonDisabled={!isFormValid}
        size="medium">
        <AddAllowanceForm innerRef={addFormikRef} setIsFormValid={setIsFormValid} />
      </RDialog>
    </Box>
  );
}
